export default function copyToClipboard(input: HTMLInputElement) {
  try {
    input.focus()
    input.select()
    return document.execCommand('copy')
  } catch (err) {
    console.log(err)
  } finally {
    input.selectionStart = 0
    input.selectionEnd = 0
    input.blur()
  }
}
